import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CREDIT_RESOLUTION_META, NOTE_STATUS_META, PROCESSING_META, RESOLUTION_META } from './inboundStatus';

function MetaChip({ meta, size = 'small' }) {
  const { t } = useTranslation();
  if (!meta) return null;
  return (
    <Chip
      label={t(meta.labelKey)}
      size={size}
      sx={{
        bgcolor: meta.bg,
        color: meta.fg,
        fontWeight: 600,
        fontSize: '12px',
        height: 22,
      }}
    />
  );
}

// The automatic run handled what it could and left rows for a person: the
// Varaosatilaukset badge already counts the note, this says why it is still open.
const AUTO_HELD_META = { fg: '#b45309', bg: '#fef3e2' };

// One combined chip for the list/detail header: parse mechanics win while the
// note is still being read (or failed), workflow status afterwards.
export function NoteStatusChip({ note, size = 'small' }) {
  const { t } = useTranslation();
  const busy = note.processing_status === 'pending' || note.processing_status === 'processing';
  const failed = note.processing_status === 'failed';
  if (busy || failed) {
    return <MetaChip meta={PROCESSING_META[note.processing_status]} size={size} />;
  }
  const autoHeld =
    note.handled_by_kind === 'auto' &&
    (note.pending_line_count || 0) > 0 &&
    (note.status === 'new' || note.status === 'reviewed');
  if (autoHeld) {
    return (
      <Chip
        label={t('inboundDeliveries.autoHeldRows', { count: note.pending_line_count })}
        size={size}
        data-testid="inbound-note-auto-held"
        sx={{ bgcolor: AUTO_HELD_META.bg, color: AUTO_HELD_META.fg, fontWeight: 600, fontSize: '12px', height: 22 }}
      />
    );
  }
  return <MetaChip meta={NOTE_STATUS_META[note.status]} size={size} />;
}

export function ResolutionChip({ resolution, credit = false, size = 'small' }) {
  const meta = (credit && CREDIT_RESOLUTION_META[resolution]) || RESOLUTION_META[resolution];
  return <MetaChip meta={meta} size={size} />;
}

export default MetaChip;
